import React from 'react';
import { Card } from 'antd';

const UsersPage: React.FC = () => {
  return (
    <div>
      <Card title="用户管理">
        <p>用户管理页面开发中...</p>
      </Card>
    </div>
  );
};

export default UsersPage; 